import angular from "angular";

angular
    .module('app')
    .component('groupSettings', {
        template: require('./group-settings.html'),
        controller: ['$http', 'Notifier', '$uibModal', 'ErrorResponseParser', 'moment', controller],
        bindings: {
            group: '<',
            course: '<',
        }
    });

function controller($http, Notifier, $uibModal, ErrorResponseParser) {


    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.name = $ctrl.group.name;
        $ctrl.cost = $ctrl.group.cost;
        $ctrl.discountValue = $ctrl.group.discount_value;
        $ctrl.onlinePayment = $ctrl.group.online_payment;
        $ctrl.offlinePayment = $ctrl.group.offline_payment;
        $ctrl.paymentInfo = $ctrl.group.payment_info;
        $ctrl.startDate = moment($ctrl.group.start_date).toDate();
    };

    $ctrl.submit = function () {

        $ctrl.loading = true;

        let startDate = moment($ctrl.startDate).format('YYYY-MM-DD');

        $http
            .post(`/admin/courses/${$ctrl.course.id}/groups/${$ctrl.group.id}/update-settings`, {
                name: $ctrl.name,
                start_date: startDate,
                cost: $ctrl.cost,
                discount_value: $ctrl.discountValue,
                online_payment: $ctrl.onlinePayment,
                offline_payment: $ctrl.offlinePayment,
                payment_info: $ctrl.paymentInfo
            })
            .then(
                function () {
                    $ctrl.loading = false;
                    Notifier.success('Успешно обновлен', 2);
                },
                function (error) {
                    $ctrl.loading = false;
                    ErrorResponseParser.parse(error);
                }
            );
    };

    $ctrl.closeGroup = function () {

        if (!confirm('Вы уверены что хотите закрыть группу?')) {
            return;
        }

        $ctrl.loading = true;

        $http
            .post(`/admin/courses/${$ctrl.course.id}/groups/${$ctrl.group.id}/close-group`)
            .then(
                function (response) {
                    $ctrl.loading = false;
                    $ctrl.isClosed = true;
                    $ctrl.group.status = 'closed';
                },
                function (error) {
                    $ctrl.loading = false;
                    ErrorResponseParser.parse(error);
                }
            );
    }

}
